/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Region } from 'src/core/types/regionTypes';

export const textAnalyticsDemosSupportedRegion: Region[] = [
    'australiaeast',
    'brazilsouth',
    'canadacentral',
    'centralindia',
    'centralus',
    'eastasia',
    'eastus',
    'eastus2',
    'francecentral',
    'germanywestcentral',
    'japaneast',
    'japanwest',
    'jioindiawest',
    'koreacentral',
    'northcentralus',
    'northeurope',
    'norwayeast',
    'qatarcentral',
    'southafricanorth',
    'southcentralus',
    'southeastasia',
    'swedencentral',
    'switzerlandnorth',
    'switzerlandwest',
    'uaenorth',
    'uksouth',
    'usgovvirginia',
    'usgovarizona',
    'westcentralus',
    'westeurope',
    'westus',
    'westus2',
    'westus3'
];

export const qnaDemoSupportedRegions: Region[] = [
    ...textAnalyticsDemosSupportedRegion,
    'centraluseuap',
    'eastus2euap',
    'westus3',
    'germanywestcentral',
    'norwayeast',
    'jioindiawest',
    'usgovvirginia'
];

export const summarizationDemoSupportedRegions: Region[] = [
    'northeurope',
    'eastus',
    'uksouth',
    'usgovvirginia',
    'southeastasia',
    'swedencentral',
    'westus',
    'australiaeast',
    'brazilsouth',
    'japaneast',
    'koreacentral',
    'westeurope',
    'switzerlandnorth',
    'centralindia',
    'eastus2',
    'francecentral',
    'northcentralus',
    'usgovarizona',
    'chinanorth3'
];
